import { render, staticRenderFns } from "./PatientHistoryTable.vue?vue&type=template&id=43cfe396"
import script from "./PatientHistoryTable.vue?vue&type=script&lang=js"
export * from "./PatientHistoryTable.vue?vue&type=script&lang=js"
import style0 from "./PatientHistoryTable.vue?vue&type=style&index=0&id=43cfe396&prod&lang=scss&scope=true"
import style1 from "./PatientHistoryTable.vue?vue&type=style&index=1&id=43cfe396&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports